import React from 'react';

import { Orbit } from '@uiball/loaders';

import './contentLoading.scss';

const ContentLoading : React.FC = () => {
  return (
    <div className={'content-loading-wrapper'}>
      <div className="content-loding">
        <Orbit size={25} speed={1.5} color='black' />
      </div>
    </div>
  )
}

export default ContentLoading;